module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyAQMAAACQ++z9AAAABlBMVEWeMDn///+ut+dDAAAAFklEQVR4AWPADkbBfyTwYYB5WMEoAABNwIDpVKi0GwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/lv.png
// module id = bYID
// module chunks = 0